import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, TrendingUp, Users, CheckCircle } from "lucide-react";
const SimpleCandidateInfoSection = () => {
  return <section className="relative py-12 sm:py-16 bg-gradient-to-b from-background to-muted/20">
      {/* Subtle background continuation */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full blur-3xl opacity-8" style={{
        background: 'radial-gradient(circle, hsl(210 65% 32% / 0.08) 0%, transparent 70%)'
      }} />
      </div>
      
      <div className="container mx-auto px-4 sm:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          
          {/* Flowing Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-4 mb-6">
              <span className="w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
              <div className="w-2 h-2 rounded-full bg-primary"></div>
              <span className="w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
            </div>
            <h2 className="text-4xl sm:text-6xl font-display font-light text-foreground mb-6 sm:mb-8 leading-[0.9]">
              Warum Sie uns vertrauen können
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Professionelle Karriereberatung in der Hospitality mit garantierter Diskretion
            </p>
          </div>

          {/* Simple Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-display font-semibold text-foreground mb-2">
                  Diskrete Betreuung
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  100% vertrauliche Abwicklung während des gesamten Bewerbungsprozesses
                </p>
              </CardContent>
            </Card>

            <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-display font-semibold text-foreground mb-2">
                  Karriereberatung
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">Strategische Laufbahnplanung </p>
              </CardContent>
            </Card>

            <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Users className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-display font-semibold text-foreground mb-2">
                  Premium Netzwerk
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  Zugang zu exklusiven Positionen bei renommierten Arbeitgebern
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Process Section */}
          <div className="mb-16">
            <div className="text-center mb-12">
              <h2 className="text-4xl sm:text-6xl font-display font-light text-foreground mb-6 sm:mb-8 leading-[0.9]">
                Wie es funktioniert
              </h2>
              
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              {/* Step 1-2 */}
              <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                      1
                    </div>
                    <h3 className="font-display font-semibold text-foreground">
                      Bewerbung senden
                    </h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed text-sm">
                    Bewerben Sie sich mit Ihren Unterlagen, entweder auf eine konkrete Stelle oder einfach initiativ. 
                    Wir prüfen diese und setzen uns kurzfristig mit Ihnen in Verbindung.
                  </p>
                </CardContent>
              </Card>

              <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                      2
                    </div>
                    <h3 className="font-display font-semibold text-foreground">
                      Telefoninterview
                    </h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed text-sm">
                    In einem ersten Telefoninterview lernen wir uns gegenseitig kennen. So gewinnen wir ein genaueres 
                    Bild über Sie, Ihre Motivation, Ihren beruflichen Werdegang und Ihre Karrierewünsche.
                  </p>
                </CardContent>
              </Card>

              <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                      3
                    </div>
                    <h3 className="font-display font-semibold text-foreground">
                      Wir suchen für Sie
                    </h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed text-sm">
                    Danach begeben wir uns auf die Suche nach der Stelle in der Hotellerie & Gastronomie, 
                    die genau Ihren Wünschen und Fähigkeiten entspricht. Sie müssen nichts unternehmen.
                  </p>
                </CardContent>
              </Card>

              <Card className="glass-effect bg-card/90 backdrop-blur-sm border-border/30">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                      4
                    </div>
                    <h3 className="font-display font-semibold text-foreground">
                      Passende Angebote
                    </h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed text-sm">
                    Haben wir ein passendes Angebot für Sie, melden wir uns bei Ihnen. Gemeinsam besprechen wir die Jobs. 
                    Ohne Ihre ausdrückliche Zustimmung versendet Scholz Interim niemals Ihre Unterlagen.
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Additional Support */}
            <div className="glass-effect bg-card/50 backdrop-blur-sm rounded-xl border border-border/30 p-6">
              <h3 className="font-display font-semibold text-foreground mb-3 text-center">
                Persönliche Begleitung
              </h3>
              <p className="text-muted-foreground leading-relaxed text-center max-w-3xl mx-auto">
                Wenn gewünscht, begleiten wir Sie im weiteren Bewerbungsverfahren auch persönlich, haken nach, 
                wenn es mal hängt und sind Ihr Ansprechpartner auch für die Fragen, die man einem Personalleiter 
                als Bewerbende vielleicht nicht stellen möchte.
              </p>
              <div className="text-center mt-4">
                <span className="text-primary font-medium text-sm">
                  Probieren Sie es einfach aus. Es lohnt sich und eröffnet Ihnen ständig neue Perspektiven.
                </span>
              </div>
            </div>
          </div>

          {/* Info Box - Free Service */}
          <div className="mb-8">
            
          </div>

          {/* Simple Call to Action */}
          <div className="text-center">
            
          </div>
        </div>
      </div>
    </section>;
};
export default SimpleCandidateInfoSection;